export enum ScriptIndic {
	Ahom = 'Ahom',
	Ariyaka = 'Ariyaka',
	Assamese = 'Assamese',
	Avestan = 'Avestan',
	Balinese = 'Balinese',
	BatakKaro = 'BatakKaro',
	BatakMandailing = 'BatakManda',
	BatakPakpak = 'BatakPakpak',
	BatakSimalungun = 'BatakSima',
	BatakToba = 'BatakToba',
	BengaliBangla = 'Bengali',
	Bhaiksuki = 'Bhaiksuki',
	Brahmi = 'Brahmi',
	BugineseLontara = 'Buginese',
	Buhid = 'Buhid',
	BurmeseMyanmar = 'Burmese',
	Chakma = 'Chakma',
	Cham = 'Cham',
	Devanagari = 'Devanagari',
	DivesAkuru = 'DivesAkuru',
	Dogra = 'Dogra',
	GondiGunjala = 'GunjalaGondi',
	GondiMasaram = 'MasaramGondi',
	Grantha = 'Grantha',
	GranthaPandya = 'GranthaPandya',
	Gujarati = 'Gujarati',
	Hanunoo = 'Hanunoo',
	Hebrew = 'Hebrew',
	JapaneseHiragana = 'Hiragana',
	JapaneseKatakana = 'Katakana',
	Javanese = 'Javanese',
	Kaithi = 'Kaithi',
	Kannada = 'Kannada',
	Kawi = 'Kawi',
	KhamtiShan = 'KhamtiShan',
	Kharoshthi = 'Kharoshthi',
	KhmerCambodian = 'Khmer',
	Khojki = 'Khojki',
	KhomThai = 'KhomThai',
	Khudawadi = 'Khudawadi',
	Lao = 'Lao',
	LaoPali = 'LaoPali',
	Lepcha = 'Lepcha',
	Limbu = 'Limbu',
	Mahajani = 'Mahajani',
	Makasar = 'Makasar',
	Malayalam = 'Malayalam',
	Marchen = 'Marchen',
	MeeteiMayekManipuri = 'MeeteiMayek',
	Modi = 'Modi',
	Mon = 'Mon',
	MongolianAliGali = 'Mongolian',
	Mro = 'Mro',
	Multani = 'Multani',
	Nandinagari = 'Nandinagari',
	NewaNepalBhasa = 'Newa',
	OldPersian = 'OldPersian',
	OriyaOdia = 'Oriya',
	Pallava = 'Pallava',
	PhagsPa = 'PhagsPa',
	PunjabiGurmukhi = 'Gurmukhi',
	RanjanaLantsa = 'Ranjana',
	Rejang = 'Rejang',
	RohingyaHanifi = 'HanifiRohingya',
	SantaliOlChiki = 'Santali',
	Saurashtra = 'Saurashtra',
	Shahmukhi = 'Shahmukhi',
	Shan = 'Shan',
	Sharada = 'Sharada',
	Siddham = 'Siddham',
	Sinhala = 'Sinhala',
	SoraSompeng = 'SoraSompeng',
	Soyombo = 'Soyombo',
	Sundanese = 'Sundanese',
	SylotiNagari = 'SylotiNagri',
	Tagalog = 'Tagalog',
	Tagbanwa = 'Tagbanwa',
	TaiLaing = 'TaiLaing',
	Takri = 'Takri',
	Tamil = 'Tamil',
	TamilBrahmi = 'TamilBrahmi',
	TamilExtended = 'TamilExtended',
	Telugu = 'Telugu',
	ThaanaDhivehi = 'Thaana',
	Thai = 'Thai',
	ThamLanna = 'TaiTham',
	ThamLao = 'LaoTham',
	ThamTaiKhuen = 'KhuenTham',
	ThamTaiLue = 'LueTham',
	Tibetan = 'Tibetan',
	TirhutaMaithili = 'Tirhuta',
	TolongSiki = 'TolongSiki',
	Urdu = 'Urdu',
	Vatteluttu = 'Vatteluttu',
	Wancho = 'Wancho',
	WarangCiti = 'WarangCiti',
	ZanabazarSquare = 'ZanabazarSquare',
}

export enum ScriptSemitic {
	Arabic = 'Arab',
	ArabicShahmukhi = 'Arab-Pa',
	ArabicUrdu = 'Arab-Ur',
	Elymaic = 'Elym',
	EthiopicAbjad = 'Ethi',
	Hatran = 'Hatr',
	HebrewJudeoArabic = 'Hebr-Ar',
	ImperialAramaic = 'Armi',
	InscriptionalPahlavi = 'Phli',
	InscriptionalParthian = 'Prti',
	Manichaean = 'Mani',
	Nabataean = 'Nbat',
	OldNorthArabian = 'Narb',
	OldSogdian = 'Sogo',
	OldSouthArabian = 'Sarb',
	Palmyrene = 'Palm',
	Persian = 'Arab-Fa',
	Phoenician = 'Phnx',
	PsalterPahlavi = 'Phlp',
	Samaritan = 'Samr',
	SemiticHebrew = 'Hebr',
	SemiticThaanaDhivehi = 'Thaa',
	Sogdian = 'Sogd',
	SyriacEastern = 'Syrn',
	SyriacEstrangela = 'Syre',
	SyriacWestern = 'Syrj',
	Ugaritic = 'Ugar',
}

export enum ScriptLatin {
	CyrillicRussian = 'RussianCyrillic',
	RomanBarahaNorth = 'BarahaNorth',
	RomanBarahaSouth = 'BarahaSouth',
	RomanColloquial = 'RomanColloquial',
	RomanDINArabic = 'ArabicDIN',
	RomanDMGPersian = 'PersianDMG',
	RomanHarvardKyoto = 'HK',
	RomanIAST = 'IAST',
	RomanIASTPI = 'IASTPali',
	RomanIPAIndic = 'IPA',
	RomanISO15919Indic = 'ISO',
	RomanISO15919PI = 'ISOPali',
	RomanISO233Arabic = 'ISO233',
	RomanISO259Hebrew = 'ISO259',
	RomanITRANS = 'Itrans',
	RomanLibraryOfCongress = 'RomanLoC',
	RomanReadable = 'RomanReadable',
	RomanSBLHebrew = 'HebrewSBL',
	RomanSemitic = 'Latn',
	RomanSemiticTypeable = 'Type',
	RomanSLP1 = 'SLP1',
	RomanTitus = 'Titus',
	RomanVelthuis = 'Velthuis',
	RomanWX = 'WX',
}

export enum ScriptSemiticLatin {
	DMGPersian = ScriptLatin.RomanDMGPersian,
	ISO233Arabic = ScriptLatin.RomanISO233Arabic,
	ISO259Hebrew = ScriptLatin.RomanISO259Hebrew,
	SBLHebrew = ScriptLatin.RomanSBLHebrew,
	SemiticAksharamukha = ScriptLatin.RomanSemitic,
	SemiticTypeableAksharamukha = ScriptLatin.RomanSemiticTypeable,
}

export enum ScriptRomanization {
	HarvardKyoto = ScriptLatin.RomanHarvardKyoto,
	IAST = ScriptLatin.RomanIAST,
	IASTPI = ScriptLatin.RomanIASTPI,
	ISO = ScriptLatin.RomanISO15919Indic,
	ISOPI = ScriptLatin.RomanISO15919PI,
	ITRANS = ScriptLatin.RomanITRANS,
	RomanColloquial = ScriptLatin.RomanColloquial,
	RomanLibraryOfCongress = ScriptLatin.RomanLibraryOfCongress,
	RomanReadable = ScriptLatin.RomanReadable,
	SLP1 = ScriptLatin.RomanSLP1,
	Titus = ScriptLatin.RomanTitus,
	Velthuis = ScriptLatin.RomanVelthuis,
	WX = ScriptLatin.RomanWX,
}

export enum ScriptIME {
	Devanagari = ScriptIndic.Devanagari,
	HarvardKyoto = ScriptLatin.RomanHarvardKyoto,
	ITRANS = ScriptLatin.RomanITRANS,
	Velthuis = ScriptLatin.RomanVelthuis,
}

export enum ScriptsExtra {
	AutoDetect = 'autodetect',
}

export const Scripts = {
	...ScriptIndic,
	...ScriptSemitic,
	...ScriptLatin,
	...ScriptSemiticLatin,
	...ScriptRomanization,
	...ScriptIME,
	...ScriptsExtra,
} as const;

export type Script =
	typeof Scripts[keyof typeof Scripts];